import { PopoverDisplayView, Inner, Arrow } from './PopoverDisplay.styles';

interface Props {
  children?: React.ReactNode;
  tooltip?: boolean;
  light?: boolean;
  arrow?: boolean;
}

export const PopoverDisplay = ({ children, tooltip, light, arrow }: Props) => (
  <>
    {arrow && <Arrow />}
    <PopoverDisplayView role="tooltip" tooltip={!!tooltip} light={!!light} arrow={!!arrow}>
      <Inner tooltip={!!tooltip}>{children}</Inner>
    </PopoverDisplayView>
  </>
);
